var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdProof(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3592 1.27295V12.4093H10.0625V14.0002H20.9997V1.27295H19.3592Z",
    fill: "#4DE0F9",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7808 13.6818H0V3.65909L0.000121816 0.318182L20.7808 0V13.6818ZM0.656234 12.7273H20.1245V0.954546L0.656234 1.16667V3.34091V12.7273Z",
    fill: "#0D5FC3",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.64258 2.22705V11.6134H3.06442V11.0566C3.06442 9.54523 3.9394 8.2725 4.97844 8.2725C6.01747 8.2725 6.89245 9.54523 6.89245 11.0566V11.6134H8.09555V2.22705H1.64258ZM4.92375 7.63614C4.15814 7.63614 3.5566 6.6816 3.5566 5.56796C3.5566 4.45432 4.21283 3.57932 4.97844 3.57932C5.74404 3.57932 6.34559 4.53387 6.34559 5.6475C6.34559 6.76114 5.68936 7.63614 4.92375 7.63614Z",
    fill: "#4DE0F9",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97848 8.11395C4.4863 8.11395 4.04881 7.87531 3.77538 7.39804C3.44726 6.92077 3.2832 6.2844 3.2832 5.64804C3.2832 4.29577 4.04881 3.18213 5.03316 3.18213C5.96283 3.18213 6.72843 4.29577 6.72843 5.72758C6.67375 7.00031 5.90814 8.11395 4.97848 8.11395ZM4.97848 4.05713C4.37693 4.05713 3.93944 4.77304 3.93944 5.56849C3.93944 5.96622 4.04881 6.36395 4.26755 6.68213C4.4863 7.00031 4.70504 7.1594 5.03316 7.1594C5.63471 7.1594 6.0722 6.44349 6.0722 5.64804C6.01751 4.77304 5.58002 4.05713 4.97848 4.05713Z",
    fill: "#0D5FC3",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21865 11.5344H6.56241V10.9776C6.56241 10.3413 6.39835 9.78445 6.12492 9.30717C5.85149 8.8299 5.414 8.59126 5.0312 8.59126C4.15622 8.59126 3.4453 9.62536 3.4453 10.8981V11.4549H2.78906V10.8981C2.78906 9.06854 3.8281 7.63672 5.08588 7.63672C5.68743 7.63672 6.23429 8.03445 6.67178 8.59126C7.10927 9.14808 7.32802 10.0231 7.32802 10.8981V11.5344H7.21865Z",
    fill: "#0D5FC3",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0859 3.6582H10.1719V4.61275H12.0859V3.6582Z",
    fill: "#0D5FC3",
    fillOpacity: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0859 6.36328H10.1719V7.31783H12.0859V6.36328Z",
    fill: "#0D5FC3",
    fillOpacity: 0.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0859 9.14746H10.1719V10.102H12.0859V9.14746Z",
    fill: "#0D5FC3",
    fillOpacity: 0.4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.789 3.6582H13.2891V4.61275H16.789V3.6582Z",
    fill: "#0D5FC3",
    fillOpacity: 0.4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0468 6.36328H13.2891V7.31783H18.0468V6.36328Z",
    fill: "#0D5FC3",
    fillOpacity: 0.4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0468 9.14746H13.2891V10.102H18.0468V9.14746Z",
    fill: "#0D5FC3",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdProof);
export default __webpack_public_path__ + "static/media/idProof.199d54af3ef6269666297eccc39f6e97.svg";
export { ForwardRef as ReactComponent };